<template>
  <v-container>
    <v-toolbar flat class="main-header mb-6">
      <v-toolbar-title class="main-header__title">
        <h1>Parameters & Controllers</h1>
      </v-toolbar-title>
      <!-- <v-spacer></v-spacer>
      <v-toolbar-items v-if="isEdited" class="main-header__contents">
        
      </v-toolbar-items> -->
    </v-toolbar>
    <hr class="mb-6" />
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <v-row v-if="isEdited">
      <v-col cols="12">
        <formWrapper :validator="$v.form">
          <form class="form-box">
            <v-textarea
              v-if="!busFormat"
              regular
              label="Type here .."
              v-model="form.value"
            ></v-textarea>
            <!-- <vue-editor v-model="form.value"></vue-editor> -->
            <!-- <form-group name="value" :attribute="`fields.value`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.value"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group> -->
          </form>
        </formWrapper>
        <v-btn
          class="success text-capitalize mt-3"
          large
          :disabled="$v.form.$invalid"
          @click="handleSave"
          ><span>Save</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :loading="loadingDataTable"
      :items="parameters"
      :mobile-breakpoint="zero"
      :items-per-page="200"
      hide-default-footer
      class="table teams"
    >
      <template v-slot:item="{ item, index }">
        <tr class="table__row">
          <td class="table__cell name text-center">
            {{ item ? item.name : "---" }}
          </td>
          <td class="table__cell text-center">
            <span v-html="item.value"></span>
          </td>
          <td class="table__cell text-center">
            {{ item ? item.unit : "---" }}
          </td>
          <td class="table__cell text-center">
            {{ item.description || "---" }}
          </td>
          <td class="table__cell text-center">
            <span
              v-if="
                permissions.includes(
                  'update_api_admin-panel_parameters_{parameter}'
                )
              "
              @click="handleEdit(item, index)"
              class="hovering mr-1 edit"
            >
              <v-icon small>mdi-pencil</v-icon><br />
              Edit
            </span>
            <span v-else>---</span>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-row class="mt-4">
      <v-col
        v-if="
          permissions.includes(
            'extendExpiry_api_admin-panel_orders_extend-expiry'
          )
        "
        sm="4"
        cols="12"
      >
        <ExpiryTime />
      </v-col>
      <v-col sm="4" cols="12">
        <ResetPassword />
      </v-col>
      <v-col sm="4" cols="12">
        <RegisterLink />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, UpdateData } from "@/helpers/apiMethods";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
// import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      zero: 0,
      headers: [],
      parameters: [],
      loadingDataTable: false,
      form: {
        value: ""
      },
      parameterIndex: "",
      isEdited: false,
      parameterId: "",
      globalServerErrors: null
    };
  },
  components: {
    ExpiryTime: () => import("./components/ExpiryTime"),
    ResetPassword: () => import("./components/ResetPassword"),
    RegisterLink: () => import("./components/RegisterLink")
    // VueEditor
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.createTableHeaders();
    this.indexparameters();
  },
  methods: {
    indexparameters() {
      this.loadingDataTable = true;
      IndexData({ reqName: `parameters` })
        .then(res => {
          const { data } = res.data;
          this.parameters = data;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    createTableHeaders() {
      const headersList = ["Name", "Value", "Unit", "Description", "Actions"];
      this.headers = TableHeaders(headersList);
    },
    handleEdit(item, index) {
      this.form.value = item.value;
      this.isEdited = true;
      this.parameterId = item.id;
      this.parameterIndex = index;
      this.scrollTop();
    },
    handleSave() {
      const value = this.getFormValue();
      UpdateData({
        reqName: `parameters`,
        data: {
          value,
          _method: "put"
        },
        id: this.parameterId
      })
        .then(res => {
          this.isEdited = false;
          this.globalServerErrors = null;
          this.$set(this.parameters, this.parameterIndex, res.data.parameter);
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    getFormValue() {
      const regex = RegExp(/<p+?>([^<|^&]*)<.p+?>/, "g");
      const isNormalText = regex.test(this.form.value);
      return isNormalText
        ? this.removeParaTag(this.form.value)
        : this.form.value;
    },
    removeParaTag(text) {
      return text.replace(/<p+?>/g, "").replace(/<.p+?>/g, "");
    }
  },
  validations: {
    form: {
      value: {
        required
      }
    }
  }
};
</script>
